import { render } from "./SignUpPage.vue?vue&type=template&id=4d6fd6df&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"

import "./SignUpPage.vue?vue&type=style&index=0&id=4d6fd6df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6fd6df"]])

export default __exports__